// Mock data for GR La Saline website

export const siteConfig = {
  clubName: "GR La Saline",
  tagline: "Gymnastique Rythmique • La Réunion",
  contact: {
    phone: "0262 33 23 76",
    email: "contact@grslasaline.fr",
    address: "La Saline les Bains, La Réunion 974"
  },
  socialLinks: {
    facebook: "https://www.facebook.com/GR%20la%20Saline%20R%C3%A9union",
    instagram: "https://www.instagram.com/gr_lasaline",
    youtube: "https://www.youtube.com/channel/UCoRMyYiRO22_1qjGJ50sz7Q",
    monClub: "https://grlasaline.monclub.app/app",
    boutique: "https://www.helloasso.com/associations/gymnastique-rythmique-et-sportive-la-saline/boutiques/boutique-gr-la-saline"
  }
};

export const heroImages = [
  "/images/hero-gr.jpg",
  "https://images.pexels.com/photos/7186303/pexels-photo-7186303.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  "https://images.pexels.com/photos/7186293/pexels-photo-7186293.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920"
];

export const featuredImages = {
  ribbon1: "https://images.pexels.com/photos/7186293/pexels-photo-7186293.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop",
  ribbon2: "https://images.pexels.com/photos/7186620/pexels-photo-7186620.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop",
  performance1: "https://images.pexels.com/photos/7186303/pexels-photo-7186303.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop",
  performance2: "https://images.pexels.com/photos/7186302/pexels-photo-7186302.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop",
  training1: "https://images.pexels.com/photos/7186300/pexels-photo-7186300.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop",
  training2: "https://images.pexels.com/photos/7186307/pexels-photo-7186307.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop"
};

export const newsItems = [
  {
    id: 1,
    title: "Ouverture des inscriptions 2026",
    date: "2026-08-15",
    category: "Inscriptions",
    excerpt: "Les inscriptions pour la saison 2026-2027 sont ouvertes ! Rejoignez-nous pour une nouvelle année pleine de performances.",
    image: featuredImages.performance1
  },
  {
    id: 2,
    title: "De belles médailles aux Championnats de France",
    date: "2026-06-30",
    category: "Résultats",
    excerpt: "Nos gymnastes ont brillé aux Championnats de France Ensemble 2026 avec de magnifiques médailles.",
    image: featuredImages.ribbon1
  },
  {
    id: 3,
    title: "Gala de Fin d'année du Club, un voyage magique",
    date: "2026-06-28",
    category: "Événements",
    excerpt: "Un spectacle inoubliable qui a émerveillé plus de 500 spectateurs. Revivez les meilleurs moments.",
    image: featuredImages.training1
  }
];

export const whatIsGR = {
  title: "Qu'est-ce que la GR ?",
  intro: "La GR (Gymnastique Rythmique) est une discipline sportive à composante artistique, principalement féminine, utilisant plusieurs engins.",
  description: "Ce sport complet allie élégance, souplesse, équilibre, grâce et développe esprit d'équipe et confiance en soi ! En effet, ce sport Olympique depuis 1984 se pratique en équipe et en individuel.",
  apparatus: [
    { name: "Ballon", icon: "ball", description: "Exprime toute la personnalité de la gymnaste" },
    { name: "Cerceau", icon: "hoop", description: "Roulements et passages dynamiques" },
    { name: "Ruban", icon: "ribbon", description: "Spirales et figures aériennes" },
    { name: "Corde", icon: "rope", description: "Sauts et mouvements rythmiques" },
    { name: "Massues", icon: "clubs", description: "Requière une bonne coordination des deux mains" }
  ]
};

export const clubInfo = {
  description: "L'association « GR La Saline » est une association loi 1901 créée en février 2012. Elle est affiliée à la FFG (Fédération Française de Gymnastique) et dépend du COREGYM (Comité Régional de Gymnastique) de La Réunion.\n\nLe club GR de la Saline ouvre ses portes aux jeunes gymnastes qui souhaitent faire de la gymnastique à La Réunion. Nous proposons des cours adaptés à l'année et des stages pendant les vacances scolaires pour tous les âges de 5 à 18 ans.",
  team: [
    { role: "Présidente", name: "Marie Dubois" },
    { role: "Entraîneur Principal", name: "Sophie Martin" },
    { role: "Trésorière", name: "Claire Lefebvre" },
    { role: "Secrétaire", name: "Julie Bernard" }
  ],
  trainingGroups: [
    {
      name: "Baby GR",
      ageRange: "5-7 ans",
      description: "Découverte de la GR en s'amusant",
      schedule: "Mercredi 14h-15h30"
    },
    {
      name: "Poussines",
      ageRange: "8-10 ans",
      description: "Apprentissage des bases techniques",
      schedule: "Mercredi 15h30-17h + Samedi 10h-12h"
    },
    {
      name: "Benjamines",
      ageRange: "11-13 ans",
      description: "Perfectionnement et compétitions",
      schedule: "Lundi 17h-19h + Mercredi 17h-19h + Samedi 14h-17h"
    },
    {
      name: "Minimes & Cadettes",
      ageRange: "14-18 ans",
      description: "Niveau avancé et compétitions régionales",
      schedule: "Mardi 18h-20h + Jeudi 18h-20h + Samedi 14h-18h"
    }
  ],
  locations: [
    {
      name: "Gymnase La Saline les Bains",
      address: "La Saline les Bains, 97434",
      isMain: true
    },
    {
      name: "Gymnase de l'Éperon",
      address: "L'Éperon, Saint-Paul",
      isMain: false
    },
    {
      name: "Gymnase Saint-Paul IV",
      address: "Saint-Paul, 97460",
      isMain: false
    },
    {
      name: "Form Horizon - Boucan",
      address: "Boucan, Saint-Paul",
      website: "www.formhorizon.fr",
      phone: "0262 33 23 76",
      isMain: false
    }
  ]
};

export const registrationInfo = {
  title: "Inscriptions 2025-2026",
  dates: [
    { date: "1er Septembre 2025", event: "Ouverture des inscriptions en ligne" },
    { date: "15 Septembre 2025", event: "Portes ouvertes et essais gratuits" },
    { date: "30 Septembre 2025", event: "Clôture des inscriptions" }
  ],
  requirements: [
    "Certificat médical de non contre-indication à la pratique de la GR",
    "Autorisation parentale pour les mineurs",
    "Photo d'identité",
    "Copie de la carte d'identité"
  ],
  fees: {
    license: "45€",
    annual: "280€",
    trimestriel: "100€"
  },
  process: "Les inscriptions se font en ligne via notre plateforme Mon Club. Cliquez sur le bouton ci-dessous pour accéder au formulaire d'inscription."
};

export const resultsData = [
  {
    year: "2025",
    competitions: [
      {
        name: "Championnat Régional - Mai 2025",
        results: [
          { athlete: "Emma Laurent", category: "Minimes", apparatus: "Ruban", medal: "Or" },
          { athlete: "Léa Moreau", category: "Benjamines", apparatus: "Cerceau", medal: "Argent" },
          { athlete: "Équipe Cadettes", category: "Ensemble", apparatus: "Mixte", medal: "Bronze" }
        ]
      },
      {
        name: "Coupe de La Réunion - Mars 2025",
        results: [
          { athlete: "Sophie Dubois", category: "Cadettes", apparatus: "Ballon", medal: "Or" },
          { athlete: "Équipe Benjamines", category: "Ensemble", apparatus: "Rubans", medal: "Or" }
        ]
      }
    ]
  },
  {
    year: "2024",
    competitions: [
      {
        name: "Championnat Régional - Juin 2024",
        results: [
          { athlete: "Marie Bernard", category: "Minimes", apparatus: "Massues", medal: "Argent" },
          { athlete: "Clara Martin", category: "Poussines", apparatus: "Corde", medal: "Bronze" }
        ]
      }
    ]
  }
];

export const galaPhotos = [
  {
    year: "2025",
    title: "Gala 2025 - Une soirée magique",
    photos: [
      featuredImages.performance1,
      featuredImages.ribbon1,
      featuredImages.training1,
      featuredImages.performance2
    ],
    videoUrl: "https://www.youtube.com/watch?v=example2025"
  },
  {
    year: "2024",
    title: "Gala 2024 - L'excellence en mouvement",
    photos: [
      featuredImages.ribbon2,
      featuredImages.training2,
      featuredImages.performance2
    ],
    videoUrl: "https://www.youtube.com/watch?v=example2024"
  }
];

export const manifesto = [
  {
    number: "01",
    title: "Ensemble",
    description: "L'esprit d'équipe et la solidarité au cœur de notre club"
  },
  {
    number: "02",
    title: "Passion",
    description: "L'amour du sport et de l'art fusionnent dans chaque performance"
  },
  {
    number: "03",
    title: "Excellence",
    description: "Viser toujours plus haut, repousser ses limites avec détermination"
  }
];
